import { Box, Typography } from "@mui/material";
import { stateWasteGeneratorStatusToLabel } from "encamp-shared/src/waste";
import { GeneratorStatusExceedanceDetailQuery } from "generated-graphql/graphql";

type CatchUp = NonNullable<
  GeneratorStatusExceedanceDetailQuery["generatorStatusExceedanceDetail"]["rcraInfoCatchUp"]
>;

/** Replaces RS's manual RCRAInfo check on findings resolved as "Corrected elsewhere". */
export function RcraInfoCatchUpNote({
  catchUp,
  showState,
}: {
  catchUp?: CatchUp | null;
  /** The finding flagged a state mismatch, so the state status is part of the answer. */
  showState: boolean;
}) {
  if (!catchUp) return null;
  const federal = stateWasteGeneratorStatusToLabel(catchUp.reportedFederalStatus ?? null);
  const reported = showState
    ? `${federal} federal, ${stateWasteGeneratorStatusToLabel(catchUp.reportedStateStatus ?? null)} state`
    : federal;
  return (
    <Box>
      <Typography variant="subtitle2" component="h4">
        RCRAInfo
      </Typography>
      <Typography variant="body2">
        {catchUp.caughtUp ? "RCRAInfo now shows" : "RCRAInfo still shows"} {reported}. Encamp's
        RCRAInfo data refreshes automatically.
      </Typography>
    </Box>
  );
}
